<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
            <router-link class="navbar-brand pb-0" to="/landing_page">
                <img src='@/assets/barter-full.png' alt='logobarter'>
                <br>
                <small :class="textColor" v-if="accountTemplateName != ''">{{ accountTemplateName.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}} </small>
                <br>
                <small class="text-danger">{{ environment }}</small>
                <!-- <img :src="logo" class="navbar-brand-img" alt="..."> -->
            </router-link>

            <!-- <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>

            <div class="row navbar-brand" >
              <span class="">BXI</span>
            </div> -->

            <slot name="mobile-right">
                <ul class="nav align-items-center d-md-none">
                    <base-dropdown class="nav-item" position="left">
                        <a slot="title" class="nav-link" href="#" role="button">
                            <div class="media align-items-center">
                              <span class="avatar avatar-sm rounded-circle">
                                <img alt="Image placeholder" src="img/theme/team-1-800x800.jpg">
                              </span>
                            </div>
                        </a>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">USER SETTINGS</h6>
                        </div>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-settings-gear-65"></i>
                            <span>Change Password</span>
                        </router-link>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-calendar-grid-58"></i>
                            <span>Activity</span>
                        </router-link>

                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">SERVER SETTINGS</h6>
                        </div>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-settings-gear-65"></i>
                            <span>Change Password</span>
                        </router-link>

                        <div class="dropdown-divider"></div>
                        <a href="#!" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>Logout</span>
                        </a>
                    </base-dropdown>
                </ul>
            </slot>
            <slot></slot>

            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                 <h1>BXI</h1>
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>

                <div v-if="developerMode != true">
                  <!--  INSERT LOOP HERE -->
                  <div v-if="!isRippleAdmin">
                    <div v-for="category in backOfficeCategories" :key="category.id">
                      <!-- Skip if CLP -->
                      <hr class="my-3" v-if="category.name != 'CLP'">
                      <h6 v-if="category.name != 'CLP'" class="navbar-heading text-muted sidebar-header" v-b-toggle="'collapse' + category.id">
                        {{ category.name }}
                        <i class="fa fa-chevron-right open-menu-icon collapse-icon "></i>
                        <i class="fa fa-chevron-down close-menu-icon collapse-icon"></i>
                      </h6>
                      <b-collapse :id="'collapse' + category.id">
                        <ul class="navbar-nav mb-md-3">
                          <div v-for="subCateg in category.raw_children" :key="subCateg.id">
                            <!-- <div v-if="subCateg.code == 'MW-002'">
                              <sidebar-item :key="subCateg.id" :link="{name: subCateg.name, icon: subCateg.icon, path: subCateg.endpoint}" />
                            </div> -->
                            <div v-if="subCateg.code == 'MW-001'">
                              <div v-if="isAccountOwner == true">
                                <sidebar-item v-if="subCateg.name != 'Ripple Admin'" :key="subCateg.id" :link="{name: subCateg.name, icon: subCateg.icon, path: subCateg.endpoint}" />
                              </div>
                              <table v-if='myWavelets.length > 0' class="table table-borderless ml-4 mt-2" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                                <tbody>
                                  <tr v-for='w in myWavelets' :key="w.id">
                                    <td class="p-0 pb-3">
                                      <img v-if='w.configuration.logo' :src="w.configuration.logo" width="20vh" height="20vh">
                                      <i v-else class="fas fa-wave-square text"></i>
                                      <a class='ml-3' add target="_blank" style="text-decoration: none; color:#000000; opacity: 0.5; font-size: 0.9rem;" :href='w.sidebar_redirect_link'>{{w.wavelet_name}}</a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-else>
                              <sidebar-item v-if="subCateg.name != 'Ripple Admin'" :key="subCateg.id" :link="{name: subCateg.name, icon: subCateg.icon, path: subCateg.endpoint}" />
                            </div>
                          </div>
                        </ul>
                      </b-collapse>
                    </div>

                    <!-- <div v-if='myWavelets.length > 0'> -->
                      <!-- <hr class="my-3">
                      <div>
                        <h6 class="navbar-heading text-muted pb-3">MY WAVELETS</h6>
                        <div v-if="(isAccountOwner == true)">
                            <ul class="navbar-nav mb-md-3">
                              <sidebar-item :link="{name: 'BXI Wavelets', 'icon': 'fas fa-wave-square text-blue', path: '/wavelets'}" />
                            </ul>
                        </div>
                        <table v-if='myWavelets.length > 0' class="table table-borderless" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                          <tbody>
                            <tr v-for='w in myWavelets' :key="w.id">
                              <td class="p-0 pb-3">
                                <img v-if='w.configuration.logo' :src="w.configuration.logo" width="20vh" height="20vh">
                                <i v-else class="fas fa-wave-square text"></i>
                                <a class='ml-3' add target="_blank" style="text-decoration: none; color:#000000; opacity: 0.5; font-size: 0.9rem;" :href='w.sidebar_redirect_link'>{{w.wavelet_name}}</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div> -->
                    <!-- </div> -->

                    <!-- <div v-if='myApps.length > 0'> -->
                    <!-- <hr class="my-3">
                    <div>
                      <h6 class="navbar-heading text-muted pb-3">MY APPS</h6>
                      <div v-if="(isAccountOwner == true)">
                          <ul class="navbar-nav mb-md-3">
                            <sidebar-item :link="{name: 'Devices', 'icon': 'fas fa-tablet-alt text-blue', path: '/devices'}" />
                            <sidebar-item :link="{name: 'BXI Apps', 'icon': 'fas fa-mobile-alt text-blue', path: '/apps'}" />
                          </ul>
                      </div>
                    </div> -->
                    <!-- </div> -->




                  </div>
                  <div v-else>
                      <h6 class="navbar-heading text-muted">ADMINISTRATION</h6>
                      <ul class="navbar-nav mb-md-3">
                          <div v-for="link in iRippleAdminLinks" :key="link.name">
                              <sidebar-item :link="link" />
                          </div>
                      </ul>
                  </div>
                </div>
                <!-- DEVELOPER MODE -->
                <div v-else>
                  <hr class="my-3">
                    <h6 class="navbar-heading text-muted">ADMINISTRATION</h6>
                    <ul class="navbar-nav mb-md-3">
                        <div>
                            <sidebar-item :link="{name: 'Wavelets', icon: 'fas fa-wave-square text-red', path: '/wavelets'}" />
                        </div>
                    </ul>
                </div>
            </div>
          </div>
    </nav>
</template>
<script>
  import NavbarToggleButton from '@/components/NavbarToggleButton'
  import HTTPRequest from '../../controllers/httpRequest.js'
  import { mapState } from 'vuex'
  import secureStorage from '../../controllers/secureStorage';

  export default {
    name: 'sidebar',
    components: {
      NavbarToggleButton
    },
    props: {
      logo: {
        type: String,
        default: 'img/brand/green.png',
        description: 'Sidebar app logo'
      },
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    data: function () {
      return {
        iRippleAdminLinks: [
          { name: 'Admin Users', icon: 'ni ni-laptop text-red', path: '/admin_users' },
          { name: 'Internal Admin', icon: 'ni ni-compass-04 text-red', path: '/internal_admin' },
          { name: 'Developers', icon: 'fas fa-user-astronaut text-red', path: '/developer_accounts' },
          { name: 'POS Updater', icon: 'fas fa-cogs text-red', path: '/pos_updater' },
          { name: 'POS Updater v2', icon: 'fas fa-cogs text-red', path: '/pos_updater_v2' },
          { name: 'Release Manager', icon: 'fas fa-refresh text-red', path: '/release_manager' },
          { name: 'Admin Logs', icon: 'ni ni-paper-diploma text-red', path: '/admin_logs' }
        ],
        backOfficeCategories: this.enabledCategories,
        userName: secureStorage.getItem("userName"),
        isRippleAdmin: secureStorage.getItem("isRippleAdmin"),
        isAccountOwner: secureStorage.getItem("isAccountOwner"),
        developerMode: secureStorage.getItem("developerMode"),
        myWavelets: [],
        myApps: [],
        accountTemplateName: secureStorage.getItem("accountTemplateName"),
        businessTypeCode: JSON.parse(localStorage.getItem("businessTypeCode")),
        environment: '',
      }
    },
    mounted: async function(){
      if (this.developerMode != true) {
        //Get My Accessible Wavelets
        var my_wavelets = await HTTPRequest.getRequest(this.endPoint + 'account_web_wavelets/get_sidebard_wavelets', null)
        this.myWavelets = my_wavelets

        //Get My Accessible Apps
        // var my_apps = await HTTPRequest.getRequest(this.endPoint + 'account_app_wavelets/get_sidebar_wavelets', null)
        // this.myApps = my_apps
      }

      const envMapping = {
            'staging': 'STAGING ENVIRONMENT',
            'hotfix': 'HOTFIX ENVIRONMENT',
            'local': 'LOCAL ENVIRONMENT'
        };
        
        const envKey = Object.keys(envMapping).find(key => this.endPoint.toLowerCase().includes(key));
        if (envKey) {
            this.environment = envMapping[envKey];
        }

      this.backOfficeCategories = this.reorderPTPModules(this.enabledCategories);
    },

    computed: {
      ...mapState(['endPoint', 'serverType',
                   'enabledCategories', 'enabledCategoryUrls', 'endPoint']),
      textColor() {
        if (this.businessTypeCode == "SUP") {
          return "text-sup";
        }
        else if (this.businessTypeCode == "FNB") {
          return "text-fnb";
        }
        else if (this.businessTypeCode == "BOU") {
          return "text-bou";
        }
        else if (this.businessTypeCode == "DRU") {
          return "text-dru";
        }
        else if (this.businessTypeCode == "HIM") {
          return "text-him";
        }
      }
    },

    watch: {
      enabledCategories() {
        this.backOfficeCategories = this.enabledCategories;
      }
    },

    methods: {
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      },
      // async getRawChildren(id) {
      //   var backofficeCategoriesRequest = await HTTPRequest.getRequest(this.endPoint + 'system_module_categories?status=A&parent_id=' + id, null)
      //   return backofficeCategoriesRequest
      // }
      reorderPTPModules(categoriesData) {
        const clonedData = JSON.parse(JSON.stringify(categoriesData));
        const ptpCategoryIndex = clonedData.findIndex(cat => cat.code === "PTP001");
        
        if (ptpCategoryIndex !== -1) {
          const ptpCategory = clonedData[ptpCategoryIndex];
          
          const sequenceOrder = [
            { position: 1, code: "PTP-004" }, // PR (Purchase Request)
            { position: 2, code: "PTP-001" }, // PO (Purchase Order)
            { position: 3, code: "PTP-006" }, // ASN (Advance Shipment Notice)
            { position: 4, code: "PTP-002" }, // RR (Receiving Report)
            { position: 5, code: "PTP-003" }, // Purchase Return
            { position: 6, code: "PTP-005" }, // Supplier Bill
            { position: 7, code: "AOC-001" }  // Add On Charge
          ];
          
          const reorderedModules = [];
          
          sequenceOrder.forEach(item => {
            const module = ptpCategory.raw_children.find(
              module => module.code === item.code
            );
            
            if (module) {
              reorderedModules.push(module);
            }
          });
          
          const remainingModules = ptpCategory.raw_children.filter(
            module => !sequenceOrder.some(item => item.code === module.code)
          );
          
          ptpCategory.raw_children = [...reorderedModules, ...remainingModules];
          
          clonedData[ptpCategoryIndex] = ptpCategory;
        }
        return clonedData;
      }
    },

    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>

<style scoped>
  .sidebar-header{
    cursor: pointer;
  }

  .collapse-icon{
    float: right;
  }

  .collapsed > .close-menu-icon,
  :not(.collapsed) > .open-menu-icon {
    display: none;
  }
  @media (min-width:801px)  {
    /* #sidenav-main::-webkit-scrollbar {
      display: none;
    } */

    #sidenav-main {
      /* -ms-overflow-style: none;  IE and Edge */
      /* scrollbar-width: none;  Firefox */
      max-width: 300px;
      overflow-x: hidden;
    }
  }

  li.text-sup::marker,
.text-sup {
  color: #297BF3;
  font-size: 6;
}

li.text-fnb::marker,
.text-fnb {
  color: #F0653A;
  font-size: 6;
}

li.text-bou::marker,
.text-bou {
  color: #6636DD;
  font-size: 6;
}

li.text-dru::marker,
.text-dru {
  color: #56CFCB;
  font-size: 6;
}

li.text-him::marker,
.text-him {
  color: #E93559;
  font-size: 6;
}

</style>
